"use strict";
// Copyright (c) StrangeBee 2023
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskStatus = void 0;
var TaskStatus;
(function (TaskStatus) {
    TaskStatus["WAITING"] = "Waiting";
    TaskStatus["IN_PROGRESS"] = "InProgress";
    TaskStatus["CANCEL"] = "Cancel";
    TaskStatus["COMPLETED"] = "Completed";
    //Don't forget to add the translation (task.my-tasks.const)
})(TaskStatus = exports.TaskStatus || (exports.TaskStatus = {}));
